
import type { SVGProps } from 'react';
const SvgAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#add_svg__a)">
      <path fill="#263E6A" d="M11.5 18.5v-6h-6v-1h6v-6h1v6h6v1h-6v6z" />
    </g>
    <defs>
      <clipPath id="add_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAdd;
